import { zebraCellClass } from "@/utils/ag-grid-excel";
import { ShortDateTimeFormat } from "@/utils/date-time.format";
import {
	ColDef,
	GetQuickFilterTextParams,
	StatusPanelDef,
	ValueFormatterParams,
} from "ag-grid-community";
import { CSSProperties } from "react";

export const AG_GRID_HEIGHT = "75vh";
export const AG_ROW_HEIGHT = 30;
export const AG_HEADER_HEIGHT = 30;

export const AG_DEFAULT_COL_DEF: ColDef = {
	resizable: true,
	sortable: true,
	suppressMenu: true,
	cellClass: zebraCellClass,
};

type StatusBar = { statusPanels: StatusPanelDef[] };

export const AG_STATUS_BAR_TOTAL: StatusBar = {
	statusPanels: [{ statusPanel: "agTotalRowCountComponent", align: "left" }],
};

export const AG_STATUS_BAR_TOTAL_FILTERED: StatusBar = {
	statusPanels: [
		{ statusPanel: "agTotalRowCountComponent", align: "left" },
		{ statusPanel: "agFilteredRowCountComponent", align: "left" },
	],
};

export const AG_STATUS_BAR_TOTAL_SELECTED: StatusBar = {
	statusPanels: [
		{ statusPanel: "agTotalRowCountComponent", align: "left" },
		{ statusPanel: "agSelectedRowCountComponent", align: "left" },
	],
};

export const dateTimeCol = (
	headerName: string,
	field: string,
	extra: ColDef = {},
): ColDef => ({
	headerName,
	field,
	minWidth: 120,
	valueFormatter: (params: ValueFormatterParams) =>
		ShortDateTimeFormat(params.value),
	getQuickFilterText: (params: GetQuickFilterTextParams) =>
		ShortDateTimeFormat(params.value),
	...extra,
});

export const cellActionsStyle: CSSProperties = {
	display: "flex",
	alignItems: "center",
	gap: 6,
	height: "100%",
};

export const rowIconButtonStyle: CSSProperties = {
	minWidth: 0,
	padding: 5,
};

export const rowButtonStyle: CSSProperties = {
	minWidth: 0,
	padding: "0 10px",
	height: 22,
	lineHeight: 1,
	fontSize: 12,
	fontWeight: 600,
	textTransform: "none",
};
